import { inputs } from '@ecosystem/newron-design-system';
import React, { useEffect, useState } from 'react';
import { sanitizeInput } from '../../common/util';
import { CustomClass } from '../../types/content/custom.types';
import constants from '../constants';

const { TextInput } = inputs;
const { MAX_CUSTOM_CLASSES_NAME_LENGTH } = constants;

type CustomClassLabelProp = {
  customClasses: CustomClass[];
  labelOnChangeFn: (label: string) => void;
  index: number;
  isLabelOptional: boolean;
  errorMessage?: string;
};

export const CustomClassLabel = ({
  customClasses,
  labelOnChangeFn,
  index,
  isLabelOptional,
  errorMessage,
}: CustomClassLabelProp) => {
  const classToRender = customClasses[index];
  const [labelText, setLabelText] = useState(classToRender.label);

  useEffect(() => {
    setLabelText(classToRender.label);
  }, [classToRender]);
  /**
   * Function to handle label change
   * @param input the input
   */
  const handleLabelChange = (input: string): void => {
    const sanitizedInput = sanitizeInput(input);
    setLabelText(sanitizedInput);
  };

  return (
    <TextInput
      key={`custom-class-label-${index}`}
      value={labelText}
      onChange={(value: string) => handleLabelChange(value)}
      onBlur={() => labelOnChangeFn(labelText)}
      isInputGroupChild={false}
      placeholder={isLabelOptional ? 'Label (optional)' : 'Label (required)'}
      onFocus={() => {}}
      testId={`custom-class-label-${index}`}
      maxLength={MAX_CUSTOM_CLASSES_NAME_LENGTH}
      errorMessage={errorMessage}
    />
  );
};
